import { UserInterface, WorkspaceMembershipsInterface } from 'shared/types/user-interface'

export const hasWorkspaces = (
  user?: UserInterface,
): user is UserInterface & { workspaceMemberships: WorkspaceMembershipsInterface[] } => {
  return (
    user?.workspaceMemberships !== undefined &&
    Array.isArray(user.workspaceMemberships) &&
    user.workspaceMemberships.length > 0
  )
}
